import { useQuery } from "@apollo/client"
import { useState } from "react"
import { toast } from 'react-toastify';
import { GET_CONVERSATION_BY_ID, GET_PATIENT_BY_ID, GET_PATIENT_CONVERSATIONS_LIST } from "../../../graphql/queries"
import { IGetProviderPatientByIdInput, IGetProviderPatientByIdOutput } from "../../../graphql/types/queries/patient"
import PleaseWait from "../../../components/PleaseWait"
import { Box, Button, Flex, Text } from "rebass/styled-components"
import { IHealthCoachGetPatientConversationsListOutput, IHealthCoachGetPatientConversationsListInput, IConversationListItem, IGetConversationByIdOutput, IIGetConversationByIdInput } from "../../../graphql/types/queries/conversation"
import { Skeleton } from "../../../components/loadingSkeleton/Skeleton"
import styled from "styled-components"
import { LoadingMessages } from "../../../components/icons/LoadingMessages"
import withSession from "../../../lib/withSession"
import { IUser } from "../../../graphql/types/queries/user"
import { Conversations } from "./CommunicatorMessager"
import { ConversationStatusCard } from "./ConversationStatusCard";
import { Tag } from "../../../components/Tag";
import moment from "moment";

export const getDateText = (waitSince: string) => {
  console.log({ waitSince })
  const date = moment(waitSince)
  const diffHours = moment().diff(date, 'hours')
  if (diffHours < 1) {
    const diffMinutes = moment().diff(date, 'minutes')
    return `${diffMinutes} min${diffMinutes > 1 ? 's' : ''} ago`
  }

  if (diffHours < 24) {
    return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`
  }

  if (moment().isSame(date, 'year')) {
    return date.format('MMM DD')
  } else {
    return date.format(`MMM DD, YYYY`)
  }
}
const CloseButtonWrapper = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;

  /* svg {
    width: 16px;
    height: 16px;
    stroke: ${({ theme }) => theme.color.primary || '#333'};
    stroke-width: 2;
  } */

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 50%;
  }

  &:focus {
    outline: none;
  }
`;

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M17.7803 7.28033C18.0732 6.98744 18.0732 6.51256 17.7803 6.21967C17.4874 5.92678 17.0126 5.92678 16.7197 6.21967L12 10.9393L7.28033 6.21967C6.98744 5.92678 6.51256 5.92678 6.21967 6.21967C5.92678 6.51256 5.92678 6.98744 6.21967 7.28033L10.9393 12L6.21967 16.7197C5.92678 17.0126 5.92678 17.4874 6.21967 17.7803C6.51256 18.0732 6.98744 18.0732 7.28033 17.7803L12 13.0607L16.7197 17.7803C17.0126 18.0732 17.4874 18.0732 17.7803 17.7803C18.0732 17.4874 18.0732 17.0126 17.7803 16.7197L13.0607 12L17.7803 7.28033Z" fill="#314351" />
  </svg>
);

const BackIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M11.6246 16.9697C11.9175 17.2626 11.9175 17.7374 11.6246 18.0303C11.3317 18.3232 10.8569 18.3232 10.564 18.0303L5.28863 12.7028C4.90381 12.3133 4.90381 11.6867 5.28863 11.2972L10.564 5.96967C10.8569 5.67678 11.3317 5.67678 11.6246 5.96967C11.9175 6.26256 11.9175 6.73744 11.6246 7.03033L7.40496 11.25L18.0943 11.25C18.5085 11.25 18.8443 11.5858 18.8443 12C18.8443 12.4142 18.5085 12.75 18.0943 12.75L7.40496 12.75L11.6246 16.9697Z" fill="#314351" />
  </svg>
);
const ListRow = styled(Flex) <{ isActive: boolean }>`
  /* <Flex alignItems={'center'} style={{ padding: '9px 14px', borderBottom: '1px solid #d6d9dc' }} width={'100%'} key={convo.id}> */
  align-items: center;
  padding: 9px 14px;
  border-bottom: 1px solid #d6d9dc;
  width: 100%;
  background: ${({ isActive }) => (isActive ? "white" : "#f9fafa")};
  cursor: pointer;

  &:hover {
    background-color: #f1f3f5;
  }

`
const List: React.FC<{
  athenaId: string
  onClose: () => void
  onSelectConversation: (item: IConversationListItem) => void
}> = ({ athenaId, onClose, onSelectConversation }) => {
  const { data: dataPatient, loading: loadingPatient } = useQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID, {
    variables: {
      id: athenaId
    }
  })
  const { data: dataPatientConvos, loading: loadingPatientConvos } = useQuery<IHealthCoachGetPatientConversationsListOutput, IHealthCoachGetPatientConversationsListInput>(GET_PATIENT_CONVERSATIONS_LIST, {
    variables: {
      patientId: athenaId || ''
    }
  })

  return (
    <Flex flex={1} width={'100%'} flexDirection={'column'} style={{ overflow: 'hidden' }}>
      <Flex justifyContent={'space-between'} style={{ padding: '0 30px', height: '70px', borderBottom: '1px solid #d6d9dc', alignItems: 'center', minHeight: '70px' }}>
        {!loadingPatient ? (
          <Text style={{ fontWeight: 600, fontSize: '16px' }}>Conversations with {dataPatient?.getProviderPatientById?.firstname}</Text>
        ) : (
          <Skeleton height={16} width={128} />
        )}
        <CloseButtonWrapper onClick={onClose}>
          <CloseIcon />
        </CloseButtonWrapper>
      </Flex>

      <Flex flex={1} style={{ padding: '30px', overflow: 'auto' }}>
        {!!loadingPatientConvos ? (
          <PleaseWait />
        ) : (
          <>
            {!dataPatientConvos || !dataPatientConvos.healthCoachGetPatientConversationsList || dataPatientConvos.healthCoachGetPatientConversationsList.length < 1 ? (
              <Text fontWeight={600} style={{ opacity: 0.5, textAlign: 'center' }}>No Conversations Found</Text>
            ) : (
              <Flex flexDirection={'column'} flex={1}>

                <Flex flexDirection={'column'} flex={1} style={{ border: '1px solid #d6d9dc', borderRadius: '6px' }}>
                  <Flex alignItems={'center'} style={{ padding: '0 14px', height: '35px', minHeight: '35px', borderBottom: '1px solid #d6d9dc' }} width={'100%'}>
                    <Text fontSize={'13px'} flex={1}>Conversation</Text>
                    <Text fontSize={'13px'} width={'150px'} style={{ paddingRight: '7px' }}>Assigned To</Text>
                    <Text fontSize={'13px'} width={'126px'} style={{ paddingRight: '7px' }}>Number</Text>
                    <Text fontSize={'13px'} width={'89px'} >Waiting</Text>
                  </Flex>

                  {dataPatientConvos.healthCoachGetPatientConversationsList.map(convo => {
                    return (
                      <ListRow isActive={convo.status === 'active'} key={convo.id} onClick={() => onSelectConversation(convo)}>
                        <Flex flex={1} alignItems={'center'} style={{ paddingRight: '7px' }}>
                          <Flex flex={1} flexDirection={'column'}>
                            <Text fontSize={'13px'} fontWeight={convo.status === 'active' ? 600 : 'initial'}>{convo.subject}</Text>
                            <Text fontSize={'13px'} style={{ opacity: 0.55, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{convo.preview}</Text>
                          </Flex>
                          <Flex justifyContent={'center'} alignItems={'center'} style={{ alignSelf: 'center', justifySelf: 'center', height: '22px', width: 'fit-content', padding: '0 6px', border: '1px solid #d6d9dc' }}>
                            <Text fontSize={'13px'} style={{ fontWeight: 600, textAlign: 'center' }}>{convo.threads}</Text>
                          </Flex>
                        </Flex>
                        <Text fontSize={'13px'} width={'150px'} fontWeight={convo.status === 'active' ? 600 : 'initial'} style={{ paddingRight: '7px' }}>{convo.assignedTo}</Text>
                        <Text fontSize={'13px'} width={'126px'} fontWeight={convo.status === 'active' ? 600 : 'initial'} style={{ paddingRight: '7px' }}>{convo.id}</Text>
                        <Text fontSize={'13px'} width={'89px'} fontWeight={convo.status === 'active' ? 600 : 'initial'} >{getDateText(convo.waiting)}</Text>
                      </ListRow>
                    )
                  })}
                </Flex>

                <Text style={{ fontSize: '13px', fontWeight: 400, marginTop: '23px', marginBottom: '40px' }}><span style={{ fontWeight: 700 }}>{dataPatientConvos.healthCoachGetPatientConversationsList.length}</span> conversation{dataPatientConvos.healthCoachGetPatientConversationsList.length > 1 ? 's' : ''}</Text>
                <Text>&nbsp;</Text>
              </Flex>
            )}</>
        )}
      </Flex>
    </Flex>
  )
}

const PreviewConvo: React.FC<{
  selectedConvo: IConversationListItem
  onClose: () => void
  onBack: () => void
}> = withSession(({ session, selectedConvo, onClose, onBack }: { session: IUser, selectedConvo: IConversationListItem, onClose: () => void, onBack: () => void }) => {
  const { data, loading, error, refetch } = useQuery<IGetConversationByIdOutput, IIGetConversationByIdInput>(GET_CONVERSATION_BY_ID, {
    variables: { conversationId: selectedConvo.id }
  })

  return (
    <Flex flex={1} width={'100%'} flexDirection={'column'} style={{ overflow: 'hidden' }}>
      <Flex justifyContent={'space-between'} style={{ padding: '0 30px', height: '70px', borderBottom: '1px solid #d6d9dc', alignItems: 'center', minHeight: '70px' }}>
        <Flex alignItems={'center'}>
          <CloseButtonWrapper onClick={onBack}>
            <BackIcon />
          </CloseButtonWrapper>
          <Text ml={2} style={{ fontWeight: 600, fontSize: '16px' }}>{selectedConvo.subject}</Text>
        </Flex>
        <Flex alignItems={'center'}>
          {!loading && data?.providerGetConversationById && (
            <>
              <Text textAlign={'left'} fontWeight={300} fontSize={'12px'} style={{ cursor: 'pointer' }} onClick={() => {

                navigator.clipboard.writeText(`https://secure.helpscout.net/conversation/${data?.providerGetConversationById.id}`);
                toast.success('Helpscout link copied in clipboard', {
                  autoClose: 1500
                })
              }}>copy HS link</Text>
              <ConversationStatusCard status={data?.providerGetConversationById.status} />
            </>
          )}

          <CloseButtonWrapper onClick={onClose}>
            <CloseIcon />
          </CloseButtonWrapper>
        </Flex>
      </Flex>

      {!!loading || !data?.providerGetConversationById ? (<Flex flex={1} marginTop={4} width='100%' height='100%' flexDirection={'column'} justifyContent='center' alignItems={'center'} >
        <LoadingMessages style={{ maxWidth: '100%' }} />
      </Flex>) : (
        <Flex flex={1} width={'100%'} style={{ overflow: 'auto', paddingBottom: '40px' }} flexDirection={'column'}>
          <Flex flexDirection={'column'} style={{ padding: '40px 100px 30px', borderBottom: '1px solid #d6d9dc', justifyContent: 'center' }}>
            <Text style={{ fontWeight: 400, fontSize: '13px', color: 'rgb(64, 82, 97)' }}><span style={{ fontSize: '14px', color: 'rgb(171, 185, 199' }}>#</span>{selectedConvo.id}</Text>
            <Text style={{ fontWeight: 500, fontSize: '20px' }}>{selectedConvo.subject}</Text>
            <Flex flex={1}>
              {data?.providerGetConversationById.tags && (
                <Flex mr={4}>
                  {data?.providerGetConversationById.tags.map(x => {
                    return (
                      <Flex key={x.tag}>
                        <Tag tag={x} />
                      </Flex>
                    )
                  })}
                </Flex>
              )}
            </Flex>
            <Button variant={'primary'} alignSelf={'center'} style={{ borderRadius: '8px', padding: '0 20px', height: '30px', fontSize: '14px' }}
              onClick={() => {
                window.open(`/messages/${selectedConvo.id}`, "_blank", "noopener,noreferrer");
              }}>Open</Button>
          </Flex>
          <Conversations conversation={[data.providerGetConversationById]} session={session} onEditDraft={() => { }} />
          <Button variant={'primary'} alignSelf={'center'} style={{ borderRadius: '8px', padding: '0 20px', height: '30px', minHeight: '30px', fontSize: '14px' }} mt={4}
            onClick={() => {
              window.open(`/messages/${selectedConvo.id}`, "_blank", "noopener,noreferrer");
            }}>Open</Button>
        </Flex>
      )
      }
    </Flex>
  )
})
export const ViewListConversations: React.FC<{
  athenaId: string
  onClose: () => void
}> = ({ athenaId, onClose }) => {
  const [selectedConvo, setSelectedConvo] = useState<null | IConversationListItem>(null)
  return (
    <Flex flex={1} width={'100%'} flexDirection={'column'} style={{ overflow: 'hidden' }}>
      {!selectedConvo ? (
        <List athenaId={athenaId} onClose={onClose} onSelectConversation={setSelectedConvo} />
      ) : (
        <PreviewConvo onBack={() => setSelectedConvo(null)} onClose={onClose} selectedConvo={selectedConvo} />)}
    </Flex>
  )
}